import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const CalendarView = lazy(async () => {
  const m = await import("@/features/habits/components/calendar-view");
  return { default: m.CalendarView };
});

/** Monthly completion calendar (global and per habit). */
function CalendarPage() {
  return (
    <Suspense fallback={null}>
      <CalendarView />
    </Suspense>
  );
}

/** Addressable calendar search via URL (#9 + #15b). */
export interface CalendarSearch {
  /** Heatmap of a specific habit (Stats → Calendar link). #9. */
  habit?: string;
  /** Visible month as `YYYY-MM` (share a specific heatmap month). #15b §3. */
  m?: string;
  /** Drill-down picker mode. Absent/`days` = days view. #15b §3. */
  view?: "months" | "years";
}

/** Valid `YYYY-MM` (month 01–12). */
const MONTH_RE = /^\d{4}-(?:0[1-9]|1[0-2])$/u;

export const calendarRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/calendar",
  validateSearch: (search: Record<string, unknown>): CalendarSearch => ({
    habit: typeof search.habit === "string" ? search.habit : undefined,
    m: typeof search.m === "string" && MONTH_RE.test(search.m) ? search.m : undefined,
    view: search.view === "months" || search.view === "years" ? search.view : undefined,
  }),
  component: CalendarPage,
});
